import { DisplayArea } from '@cornerstonejs/core/types';

const centerDisplayArea: DisplayArea = {
	type: 'FIT',
	storeAsInitialCamera: true,
	imageCanvasPoint: {
		imagePoint: [0.5, 0.5],
		canvasPoint: [0.5, 0.5],
	},
};

// căn lề trái từ góc nhìn người đọc
const rightDisplayArea: DisplayArea = {
	type: 'FIT',
	storeAsInitialCamera: true,
	imageCanvasPoint: {
		imagePoint: [0, 0.5],
		canvasPoint: [0, 0.5],
	},
};

// căn lề phải từ góc nhìn người đọc
const leftDisplayArea: DisplayArea = {
	type: 'FIT',
	storeAsInitialCamera: true,
	imageCanvasPoint: {
		imagePoint: [1, 0.5],
		canvasPoint: [1, 0.5],
	},
};

// căn lề trên
const topDisplayArea: DisplayArea = {
	type: 'FIT',
	storeAsInitialCamera: true,
	imageCanvasPoint: {
		imagePoint: [0.5, 0],
		canvasPoint: [0.5, 0],
	},
};

// căn lề dưới
const bottomDisplayArea: DisplayArea = {
	type: 'FIT',
	storeAsInitialCamera: true,
	imageCanvasPoint: {
		imagePoint: [0.5, 1],
		canvasPoint: [0.5, 1],
	},
};

const displayAreaMap: Record<string, DisplayArea> = {
	left: rightDisplayArea,
	right: leftDisplayArea,
	top: topDisplayArea,
	bottom: bottomDisplayArea,
	center: centerDisplayArea,
};

export { bottomDisplayArea, displayAreaMap, leftDisplayArea, rightDisplayArea, topDisplayArea };
